import React, { useMemo } from "react";
import { Layout, Row, Tooltip } from "antd";
import AvatarDropDown from "./components/AvatarDropDown";
import WhiteSpace from "components/base/WhiteSpace";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  BulbFilled,
  BulbOutlined,
} from "@ant-design/icons";
import { useTheme } from "themes/useTheme";
import useSizeMediaQuery from "hooks/useSizeMediaQuery";
import Search from "./components/Search";
import LanguageSwitcher from "locales/components/LanguageSwitcher";
import styled from "themes/styled";
import ThemeSwitcher from "themes/components/ThemeSwitcher";
import { useFullscreen } from "components/AppConfig/hooks";

const { Header } = Layout;

interface IProps {
  collapsed: boolean;
  onToggle: () => void;
}

const Navbar = (props: IProps) => {
  const { collapsed, onToggle } = props;

  const { themeVariables } = useTheme();

  const size = useSizeMediaQuery();

  const isMobile = useMemo(() => ["xs", "sm"].includes(size), [size]);

  const IconComponent = isMobile
    ? MenuUnfoldOutlined
    : collapsed
    ? MenuUnfoldOutlined
    : MenuFoldOutlined;

  const [fullScreen] = useFullscreen();

  return (
    <>
      <StyledHeader
        style={{
          height: fullScreen ? 0 : undefined,
          overflow: fullScreen ? "hidden" : undefined,
        }}
      >
        <Row align="middle" justify="space-between">
          <Row align="middle">
            <IconComponent
              className="trigger"
              style={{
                paddingLeft: themeVariables.spacing_md,
                paddingRight: themeVariables.spacing_md,
                fontSize: 18,
              }}
              onClick={onToggle}
            />
            {/* <Search /> */}
          </Row>

          <Row align="middle">
            <ThemeSwitcher />
            <WhiteSpace horizontal size="lg" />
            <LanguageSwitcher />
            <WhiteSpace horizontal size="lg" />
            <AvatarDropDown />
          </Row>
        </Row>
      </StyledHeader>
    </>
  );
};

const StyledHeader = styled(Header)`
  background-color: ${(props) => props.theme.background_color} !important;
  padding: 0px !important;
  height: 60px;
  transition: width 0.2s ease;
  transition: height 0.2s ease;
  position: sticky;
  top: 0;
  right: 0;
  z-index: 100;
`;

export default React.memo(Navbar);
